import { render } from "./GlobalWrapper.vue?vue&type=template&id=913f9992"
import script from "./GlobalWrapper.vue?vue&type=script&lang=js"
export * from "./GlobalWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__